import { createFileRoute } from "@tanstack/react-router";
import { hasAction } from "@core/permissions";
import { CohortScreen } from "@modules/cohorts/views";
import { useCohort } from "@modules/cohorts";
import { CohortAppels } from "@modules/appels/views";

export const Route = createFileRoute("/_staff-area/cohorts/$cohortId/")({
  staticData: { title: "nav.cohorts" },
  component: CohortRoute,
});

// The cohort page composes its « Appels » section from the appels module: modules never import one
// another, so the route is where the two meet.
function CohortRoute() {
  const { cohortId } = Route.useParams();
  const cohort = useCohort(cohortId);

  return (
    <CohortScreen
      cohortId={cohortId}
      appels={
        cohort.data ? (
          <CohortAppels
            cohortId={cohortId}
            appels={cohort.data.rounds ?? []}
            canCreate={hasAction(cohort.data.available_actions, "create_appel")}
            nextName={cohort.data.next_appel?.name ?? ""}
          />
        ) : null
      }
    />
  );
}
